import React from 'react';

import {
  Group,
  Panel,
  PanelHeader,
  Spacing,
} from '@vkontakte/vkui';

import { OthersPredictionBox } from './components/OthersPredictionBox';
import { SelfPredictionBox } from './components/SelfPredictionBox';
import styles from './DesktopPredictionPanel.module.css';
import { DesktopPredictionPanelProps } from './types';
import { Footer } from '../../../../../components/Footer/Footer';
import { HeaderImage } from '../../components/HeaderImage';

export const DesktopPredictionPanel: React.FC<DesktopPredictionPanelProps> = ({
  id,
  goToAboutUs,
  handleGetFriendTemperamentClick,
  handleGetMyTemperamentClick
}) => {


  return (
    <Panel id={id} className={styles.panel}>
      <PanelHeader>
          AI-профориентатор
      </PanelHeader>
      <Group className={styles.container} separator="hide">
        <HeaderImage/>
        <Spacing size={40} />
        <div className={styles.informativeContent}>
          <SelfPredictionBox 
            goToAboutUs={goToAboutUs}
            handleGetMyTemperamentClick={handleGetMyTemperamentClick}
          />
          <div className={styles.separator} />
          <OthersPredictionBox handleGetFriendTemperamentClick={handleGetFriendTemperamentClick}/>
        </div>
        <Footer/>
      </Group>
    </Panel>
  );
};
